import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fc689ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "subjob-modal-label"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Date", -1))
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Inspector", -1))
const _hoisted_16 = { class: "col-sm-8" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  key: 0,
  class: "col-md-1"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_22 = { class: "col-md-7" }
const _hoisted_23 = { class: "col-md-1" }
const _hoisted_24 = {
  key: 0,
  class: "fas fa-redo"
}
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = { class: "form-group row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "Timing", -1))
const _hoisted_28 = { class: "col-md-4 pr-0" }
const _hoisted_29 = { class: "col-md-4 pl-0" }
const _hoisted_30 = { class: "form-group row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label offset-1" }, "PI Notes", -1))
const _hoisted_32 = { class: "col-md-8 pr-0" }
const _hoisted_33 = {
  key: 0,
  class: "col-6 leadbooking-detail-container"
}
const _hoisted_34 = { class: "modal-footer" }
const _hoisted_35 = ["disabled"]

import $ from 'jquery';
import { ref, computed, watch, onMounted, inject, nextTick, PropType } from 'vue';
import moment from 'moment-timezone';
import { useStore } from 'vuex';
import { DxDateBox } from 'devextreme-vue/date-box';
import { Booking, Inspector, Location, ReportTiming, SelectOption} from '@/models';
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from 'vue-router';
import { emitEvent } from '@/eventBus';
import { toRawObject } from '@/utilities';
import BookingDetail from "@/components/diary/BookingDetail.vue";
import RevisitDetail from './RevisitDetail.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubJobModal',
  props: {
    id: {}
  },
  emits: ['hide', 'updatedsubbooking'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit

const store = useStore();
const toasted = useToast();
const route = useRoute();
const actProperty: any = inject('actProperty');
const realtime: any = inject('realtime');

const channel = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

const operation = ref('');
const booking = ref<Booking>(new Booking());
const subjobtype = ref('');
const subjobbooking = ref(new Booking());
const selectedinspector = ref(new Inspector());
const subjobdate = ref(new Date());
const starttimeoptions = ref<string[]>([]);
const endtimeoptions = ref<string[]>([]);
const appointmenttimeoptions = ref<string[]>([]);
const isSaving = ref(false);

const dynamicRefs = ref({});

const props = __props;

// Getters
const _currentdate = computed((): Date => store.getters['diary/currentdate']);
const recommendedtime = computed((): number => store.getters['diary/recommendedtime']);
const bookings = computed((): Booking[] => store.getters['diary/list']);
const inspectors = computed((): Inspector[] => store.getters['diary/inspectorlist']);

// Actions and Mutations converted to functions
const addBooking = async (booking: Booking) => store.dispatch('diary/addBooking', booking);
const saveBooking = async (booking: Booking) => store.dispatch('diary/saveBooking', booking);
const restoreBookingInStore = async (booking: Booking) => store.dispatch('diary/restoreBooking', booking);
const updateBooking = async (booking: Booking) => store.commit('diary/updateBooking', booking);

onMounted(async () => {
  Promise.all([setStartTimeOptions(), setEndTimeOptions()])
    .then((values) => {})
    .catch((err) => {
      actProperty.displayError(err);
    });
});

const init = (book: Booking, sbt: string) => {
  booking.value = book;
  subjobtype.value = sbt;
  subjobbooking.value = Booking.forSubbooking(book);
  selectedinspector.value = new Inspector();
}

const add = () => {
  operation.value = "add";
  subjobbooking.value.auditlogs = [];
  subjobbooking.value.subtype = subjobtype.value;
  subjobdate.value = subjobbooking.value.startdateAsDate;
  if (subjobtype.value === Booking.PREP) {
    let sdateMoment = moment(booking.value.startdate).utc();
    let daystodeduct = -1;
    // If it is Monday, go back to Saturday
    if (sdateMoment.day() === 1) daystodeduct = -2;
    subjobdate.value = sdateMoment.add(daystodeduct, "days").toDate();
  }
  if (subjobtype.value != Booking.SHARED) {
    selectedinspector.value = booking.value.inspector;
  }

  if(route.name === 'newbooking'  || route.name === 'existingbooking') {
    // Change the date on the Diary to show 
    publishCurrentdateChange(moment(subjobdate.value)
      .utc()
      .format(actProperty.bookingdateformat));
  }
}

const edit = () => {
  operation.value = "edit";
  subjobdate.value = subjobbooking.value.startdateAsDate;
  selectedinspector.value = booking.value.inspector;

  if(route.name === 'newbooking'  || route.name === 'existingbooking') {
    // Change the date on the Diary to show 
    publishCurrentdateChange(moment(subjobdate.value)
      .utc()
      .format(actProperty.bookingdateformat));
  }
}


const setStartTimeOptions = () => {
  starttimeoptions.value = [];
  let startmoment = moment().set("hour", 6).set("minute", 0);
  for (let i = 0; i < 62; i++) {
    const hourMinutes = startmoment.format("hh:mm A");
    starttimeoptions.value.push(hourMinutes);
    appointmenttimeoptions.value.push(hourMinutes);
    startmoment.add(15, "minutes");
  }
}

const _startdate = computed({
  get: () => {
    let value = subjobbooking.value.startdate
      ? moment(subjobbooking.value.startdate).utc().format("hh:mm A")
      : "";
    const index = starttimeoptions.value.findIndex(
      (option: string) => option === value
    );
    if (index < 0) value = "";
    return value;
  },
  set: (val: string) => {
    subjobbooking.value.startdate = subjobendDate(
      val,
      subjobbooking.value.startdateAsDate
    );
    determinEnddate();
    determineAppointmenttime();
  }
});


watch(() => _startdate.value, (newValue) => {
  setEndTimeOptions();
});

const setEndTimeOptions = () => {
  endtimeoptions.value = [];
  let startmoment = moment().set("hour", 6).set("minute", 0);
  if (_startdate.value) {
    startmoment = moment(_startdate.value, "hh:mm A");
    startmoment.add(15, "minutes");
  }
  for (let i = 0; i < 62; i++) {
    const hourMinutes = startmoment.format("hh:mm A");
    endtimeoptions.value.push(hourMinutes);
    startmoment.add(15, "minutes");
    if (hourMinutes === "09:00 PM ") break;
  }
}

const _enddate = computed({
  get: () => {
    let value = subjobbooking.value.enddate
      ? moment(subjobbooking.value.enddate).utc().format("hh:mm A")
      : "";
    const index = endtimeoptions.value.findIndex(
      (option: string) => option === value
    );
    if (index < 0) value = "";
    return value;
  },
  set: (val: string) => {
    subjobbooking.value.enddate = subjobendDate(
      val,
      subjobbooking.value.startdateAsDate
    );
    let duration = subjobbooking.value.duration;
    if (duration === subjobbooking.value.recommendedtime) duration = 0;
    subjobbooking.value.preferredduration = duration;
    determineAppointmenttime();
  }
});

const determinEnddate = () => {
  if (subjobbooking.value.startdate && subjobbooking.value.recommendedtime) {
    let time = booking.value.preferredduration > 0
      ? booking.value.preferredduration
      : subjobbooking.value.recommendedtime;
    subjobbooking.value.enddate = subjobendDate(
      moment(subjobbooking.value.startdate).utc().add(time, 'minutes').format('hh:mm A'),
      subjobbooking.value.startdateAsDate
    );
  }
};

const determineAppointmenttime = () => {
  let appointmenttime = '';
  let timeinminutes = 0;
  if (booking.value.preferredappointmenttime > 0)
    timeinminutes = booking.value.preferredappointmenttime;
  else if (subjobbooking.value.recommendedappointmenttime > 0)
    timeinminutes = subjobbooking.value.recommendedappointmenttime;

  // Round it to the nearest 15 minutes interval
  timeinminutes = Math.round(timeinminutes / 15) * 15;
  if (subjobbooking.value.enddate && timeinminutes > 0) {
    appointmenttime = moment(subjobbooking.value.enddate).utc().subtract(timeinminutes, 'minutes').format('hh:mm A');
  } else if (subjobbooking.value.startdate) {
    appointmenttime = moment(subjobbooking.value.startdate).utc().format('hh:mm A');
  }
  subjobbooking.value.appointmenttime = subjobendDate(
    appointmenttime,
    subjobbooking.value.startdateAsDate
  );
};

const _preferredduration = computed(() => {
  return convertToHoursMinutes(subjobbooking.value.preferredduration);
});

const pinotes = computed({
  get: () => subjobbooking.value.pinotes,
  set: (val: string) => {
    subjobbooking.value.pinotes = val;
  }
});

const convertToHoursMinutes = (val: number) => {
  let hourMinutes = moment.utc().startOf('day').add(val, 'minutes').format('HH [Hours] mm [Minutes]');
  hourMinutes = hourMinutes.replaceAll('00 Hours', '');
  hourMinutes = hourMinutes.replaceAll('00 Minutes', '');
  return hourMinutes;
};

const restore = () => {
  restoreBookingInStore(booking.value)
    .then(() => {
      toasted.success('Booking restored');
      channel.publish('appointmentRestored', { deviceid, bookingid: booking.value.id });
    })
    .catch((err: any) => actProperty.displayError(err));
};

const save = async () => {
  hide();
  if (selectedinspector.value.id) {
    isSaving.value = true;
    if (operation.value === "add") {
      subjobbooking.value.id = "";
      if (!subjobbooking.value.leadbooking)
        subjobbooking.value.leadbooking = new Booking();
      subjobbooking.value.leadbooking.id = booking.value.id;
      if (subjobtype.value === Booking.PREP &&
          booking.value.jobtype === "checkin") {
        // https://trello.com/c/M96MSsLb/513-change-of-terminology-for-ci-prep
        //subjobbooking.value.jobtype = "inventory";
      }
      subjobbooking.value.inspector = selectedinspector.value;
      subjobbooking.value.startdate = subjobendDate(
        subjobbooking.value.starttime,
        subjobdate.value
      );
      subjobbooking.value.enddate = subjobendDate(
        subjobbooking.value.endtime,
        subjobdate.value
      );
      addBooking(subjobbooking.value)
        .then(async (b: Booking) => {
          channel.publish('newAppointmentAdded', {deviceid: deviceid, bookingid: b.id});
          booking.value.addSubbooking(b);
          if (
            subjobtype.value === Booking.PREP &&
            (booking.value.jobtype === "inventory" ||
            booking.value.jobtype === "checkin")
          ) {
            // https://trello.com/c/4wJJyycV/512-adding-a-prep-to-an-inventory-check-in
            //booking.value.jobtype = "checkin";
            //booking.value.internaljobtype = "Check-In - off ACT report";
            
            // Change the timing to reflect schedule
            // Check-In following Check-Out less than 24 hours ago or following an Inventory Prep - off ACT report or upload and same PI
            let timing: ReportTiming | undefined =
              actProperty.determineRecommendedtime(
                booking.value,
                "Check-In following Check-Out less than 24 hours ago or following an Inventory Prep - off ACT report or upload and same PI"
              );
            if (timing) {
              // eslint-disable-next-line vue/no-mutating-props
              booking.value.startdate = actProperty.prependDate(
                moment(booking.value.enddate)
                  .utc()
                  .subtract(timing.timing, "minutes")
                  .format("hh:mm A"),
                booking.value.startdate,
                booking.value.enddateAsDate
              );
            }
          }
          await saveBooking(booking.value).then((b: Booking) => {
            isSaving.value = false;
            toasted.success(`Added ${subjobtype.value}`);
            updateBooking(booking.value);
            // Update children
            let children: Booking[] = bookings.value.filter((b: Booking) => b.leadbooking?.id === booking.value.id);
            if(children?.length) {
              children.forEach((b: Booking) => {
                b.leadbooking = new Booking(booking.value);
                updateBooking(b);
              });
            }
            channel.publish('appointmentChanged', {deviceid: deviceid, bookingid: booking.value.id, source: 'SubJobModal'} );
          });
        })
        .catch((err: any) => {
          isSaving.value = false;
          actProperty.displayError(err);
        });
    } else {
      subjobbooking.value.inspector = selectedinspector.value;
      subjobbooking.value.startdate = subjobendDate(
        subjobbooking.value.starttime,
        subjobdate.value
      );
      subjobbooking.value.enddate = subjobendDate(
        subjobbooking.value.endtime,
        subjobdate.value
      );
      await saveBooking(subjobbooking.value)
        .then(() => {
          isSaving.value = false;
          channel.publish('appointmentChanged', {deviceid: deviceid, bookingid: subjobbooking.value.id, source: 'SubJobModal'} );
          emitEvent("appointmentChangedInBookingTemplate", subjobbooking.value);
          emit('updatedsubbooking', subjobbooking.value);
        })
        .catch((err: any) => {
          isSaving.value = false;
          actProperty.displayError(err);
        });
    }
  }
};

const subjobendDate = (time: string, date: Date) => {
  let value = "";
  if (time) {
    let dt = date ? date : _currentdate.value;
    let justdate = moment(dt).utc().format("YYYY-MM-DD");
    let justtime = moment(time, "hh:mm A").format("HH:mm");
    value = `${justdate}T${justtime}:00.000Z`;
  }
  return value;
};

const setCurrentdate = (e: any) => {
  if (route.name === 'newbooking' || route.name === 'existingbooking') {
    publishCurrentdateChange(moment(e.value).utc().format(actProperty.bookingdateformat));
  }
};

const publishCurrentdateChange = (val: string) => {
  channel.publish('currentdateChanged', { deviceid, bookingdate: val });
};

const inspectorlist = computed((): SelectOption[] => {
  const activeinspectors = inspectors.value.filter((i) => !i.inactive);
  let sortedlist = actProperty.sortInspectorList(activeinspectors, {
    previousreport: booking.value?.basereport,
    postcode: booking.value?.address?.postcode,
  });

  if (subjobtype.value === Booking.SHARED) {
    sortedlist = sortedlist.filter(
      (i: Inspector) => i.id != booking.value?.inspector?.id
    );
  }
  return sortedlist.map(
    (insp: Inspector) => new SelectOption({ name: insp.name, slug: insp.id })
  );
});

const inspector = computed({
  get: () => {
    let insp = inspectors.value.find((i) => i.id == selectedinspector.value.id);
    return new SelectOption({ name: insp?.name, slug: insp?.id });
  },
  set: (val: SelectOption) => {
    if (val) {
      let insp = inspectors.value.find((i) => i.id == val.slug);
      if (insp) {
        selectedinspector.value = insp;
      }
    }
  }
});
const resetInspector = () => {
  selectedinspector.value = new Inspector();
}

const leadbooking = computed(() => {
  if(booking.value?.leadbooking?.id) return booking.value.leadbooking;
  else return booking.value;
})

const getRating = (option: any): number => {
  let inspector = option && option.slug 
    ? inspectors.value.find((i: Inspector) => i.id === option.slug)
    : undefined;

  let rating = 0;
  if (inspector?.locations?.length && booking.value?.address?.postcode) {
    let postcode = booking.value.address.postcode.replace(/ /g, "");
    let areacode = postcode.substring(0, postcode.length - 3);
    if (areacode) {
      let location = inspector.locations.find((l: Location) => l.code.trim() === areacode.trim());
      if (location) rating = location.rating;
    }
  }
  return rating;
};

const previousPI = (option: any): boolean => {
  let inspector = inspectors.value.find((i: Inspector) => i.id === option.slug);
  return inspector && booking.value?.basereport?.user
    ? inspector.email === booking.value.basereport.user
    : false;
};

const getPiNameColClass = (option: any) => {
  let rating = getRating(option);
  let previous = previousPI(option);
  let columns = 11;
  if (rating) columns -= 4;
  if (previous) columns -= 1;
  return `col-md-${columns}`;
};

const dropDownOpened = (ref: string) =>{
  nextTick(() => {
    // Get the reference to the dropdown list container
    const multiselect = dynamicRefs.value[ref] as any;
    const dropdownList = multiselect.$el.querySelector('.multiselect__content-wrapper');

    // Get the reference to the selected option element
    const selectedOption = multiselect.$el.querySelector('.multiselect__option--selected');

    // Scroll to the position of the selected element
    if(selectedOption?.offsetTop)
      dropdownList.scrollTop = selectedOption.offsetTop;
  });
}

const savingAllowed = computed(() => {
  let result = false;
  if (selectedinspector.value && selectedinspector.value.id && subjobdate.value)
    result = true;
  return result;
});

const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.id}`).show();
  }
}
const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
    $(`#${props.id}`).hide();
    emit('hide')
  }
};

__expose({init, add, edit, show, hide});

const customLabel = (option: string) => {
  return option.replace(/^0/, '');
}

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "modal",
    "data-backdrop": "false",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`subjob-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", {'modal-xl': operation.value === 'edit'}]),
      role: "document"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, [
            (operation.value === 'add')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Add " + _toDisplayString(subjobtype.value) + " job", 1))
              : _createCommentVNode("", true),
            (operation.value === 'edit')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Edit " + _toDisplayString(subjobtype.value) + " job", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            id: "close",
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass({'col-6': operation.value === 'edit', 'col-12': operation.value === 'add'})
            }, [
              _createElementVNode("form", null, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_unref(DxDateBox), {
                        modelValue: subjobdate.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subjobdate).value = $event)),
                        "display-format": "dd/MM/yyyy",
                        type: "date",
                        "picker-type": "calendar",
                        "apply-value-mode": "instantly",
                        calendarOptions: {firstDayOfWeek:1},
                        onValueChanged: setCurrentdate,
                        disabled: subjobtype.value === 'Shared'
                      }, null, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_singleselect_text, {
                        modelValue: inspector.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inspector).value = $event)),
                        "track-by": "slug",
                        options: inspectorlist.value,
                        "allow-empty": true,
                        taggable: false,
                        disabled: subjobtype.value === 'Key',
                        class: "no-padding"
                      }, _createSlots({
                        singleLabel: _withCtx(({ option }) => [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", {
                              class: _normalizeClass(getPiNameColClass(option))
                            }, _toDisplayString(option.name), 3),
                            (previousPI(option))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                              : _createCommentVNode("", true),
                            (getRating(option))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRating(option), (index) => {
                                    return (_openBlock(), _createElementBlock("i", {
                                      key: index,
                                      class: "fas fa-star"
                                    }))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        option: _withCtx(({ option }) => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["row", {
                              green: getRating(option) >= 2,
                              amber: getRating(option) == 1,
                              red: getRating(option) == 0,
                            }])
                          }, [
                            _createElementVNode("div", _hoisted_22, _toDisplayString(option.name), 1),
                            _createElementVNode("div", _hoisted_23, [
                              (previousPI(option))
                                ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRating(option), (index) => {
                                return (_openBlock(), _createElementBlock("i", {
                                  key: index,
                                  class: "fas fa-star"
                                }))
                              }), 128))
                            ])
                          ], 2)
                        ]),
                        _: 2
                      }, [
                        (selectedinspector.value && selectedinspector.value.id)
                          ? {
                              name: "clear",
                              fn: _withCtx(() => [
                                _createElementVNode("i", {
                                  onMousedown: _withModifiers(resetInspector, ["prevent","stop"]),
                                  class: "multiselect__clear fa fa-times",
                                  "aria-label": "Clear Who"
                                }, null, 32)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["modelValue", "options", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_singleselect_text, {
                        modelValue: _startdate.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_startdate).value = $event)),
                        options: starttimeoptions.value,
                        customLabel: customLabel,
                        "allow-empty": true,
                        taggable: false,
                        ref: el => { dynamicRefs.value['startDateDropDown'] = el },
                        onOpen: _cache[5] || (_cache[5] = ($event: any) => (dropDownOpened('startDateDropDown')))
                      }, _createSlots({ _: 2 }, [
                        (_startdate.value)
                          ? {
                              name: "clear",
                              fn: _withCtx(() => [
                                _createElementVNode("i", {
                                  onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_startdate.value = ''), ["prevent","stop"])),
                                  class: "multiselect__clear fa fa-times",
                                  "aria-label": "Clear Start Time"
                                }, null, 32)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_singleselect_text, {
                        modelValue: _enddate.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_enddate).value = $event)),
                        options: endtimeoptions.value,
                        customLabel: customLabel,
                        "allow-empty": true,
                        taggable: false,
                        ref: el => { dynamicRefs.value['endDateDropDown'] = el },
                        onOpen: _cache[8] || (_cache[8] = ($event: any) => (dropDownOpened('endDateDropDown')))
                      }, _createSlots({ _: 2 }, [
                        (_enddate.value)
                          ? {
                              name: "clear",
                              fn: _withCtx(() => [
                                _createElementVNode("i", {
                                  onMousedown: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_enddate.value = ''), ["prevent","stop"])),
                                  class: "multiselect__clear fa fa-times",
                                  "aria-label": "Clear End Time"
                                }, null, 32)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["modelValue", "options"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        rows: "3",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((pinotes).value = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          pinotes.value,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ])
                  ])
                ])
              ])
            ], 2),
            (operation.value === 'edit')
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (subjobtype.value === 'Revisit')
                    ? (_openBlock(), _createBlock(RevisitDetail, {
                        key: 0,
                        booking: leadbooking.value,
                        leadbooking: leadbooking.value
                      }, null, 8, ["booking", "leadbooking"]))
                    : (_openBlock(), _createBlock(BookingDetail, {
                        key: 1,
                        booking: leadbooking.value,
                        leadbooking: leadbooking.value,
                        prepandkeybookings: booking.value
                      }, null, 8, ["booking", "leadbooking", "prepandkeybookings"]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          (operation.value === 'edit' && booking.value.cancelled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-secondary mr-auto",
                "data-dismiss": "modal",
                onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (restore()), ["prevent"]))
              }, " Restore "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            "data-dismiss": "modal",
            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (save()), ["prevent"])),
            disabled: isSaving.value || !savingAllowed.value
          }, " Save ", 8, _hoisted_35)
        ])
      ])
    ], 2)
  ], 8, _hoisted_1))
}
}

})